module.exports = __webpack_public_path__ + "img/data_maintenance.d39cb993.svg";